import { useEffect, useState } from 'react';
import { api } from '../App';

const AuthDebug = () => {
  const [debugInfo, setDebugInfo] = useState({
    currentUrl: window.location.href,
    hash: window.location.hash,
    hasSessionId: window.location.hash.includes('session_id'),
    sessionId: '',
    cookies: document.cookie,
    backendUrl: process.env.REACT_APP_BACKEND_URL,
    apiBase: api.defaults.baseURL,
    sessionCheckResult: null,
    sessionCheckError: null
  });

  useEffect(() => {
    // Extract session_id if present
    const hash = window.location.hash;
    if (hash.includes('session_id=')) {
      const sessionId = hash.split('session_id=')[1].split('&')[0];
      setDebugInfo(prev => ({ ...prev, sessionId }));
    }

    // Try to check session
    checkSession();
  }, []);

  const checkSession = async () => {
    try {
      const response = await api.get('/auth/session');
      setDebugInfo(prev => ({
        ...prev,
        sessionCheckResult: 'SUCCESS - User is logged in',
        userData: response.data
      }));
    } catch (error) {
      setDebugInfo(prev => ({
        ...prev,
        sessionCheckError: error.response?.data?.detail || error.message,
        sessionCheckStatus: error.response?.status
      }));
    }
  };

  const testProcessSession = async () => {
    if (!debugInfo.sessionId) {
      alert('No session_id found in URL');
      return;
    }

    try {
      const response = await api.post('/auth/process-session', {}, {
        headers: { 'X-Session-ID': debugInfo.sessionId }
      });
      setDebugInfo(prev => ({
        ...prev,
        processResult: 'SUCCESS',
        processData: response.data
      }));
      alert('Session processed! Try refreshing the page.');
    } catch (error) {
      setDebugInfo(prev => ({
        ...prev,
        processError: error.response?.data?.detail || error.message
      }));
      alert('Error: ' + (error.response?.data?.detail || error.message));
    }
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace', fontSize: '12px' }}>
      <h1 style={{ fontSize: '24px', marginBottom: '20px' }}>🔍 Auth Debug Page</h1>
      
      <div style={{ backgroundColor: '#f5f5f5', padding: '15px', marginBottom: '15px', borderRadius: '8px' }}>
        <h2 style={{ fontSize: '16px', marginBottom: '10px' }}>Current URL Info:</h2>
        <div><strong>Full URL:</strong> {debugInfo.currentUrl}</div>
        <div><strong>Hash:</strong> {debugInfo.hash || '(none)'}</div>
        <div><strong>Has session_id?</strong> {debugInfo.hasSessionId ? '✅ YES' : '❌ NO'}</div>
        {debugInfo.sessionId && (
          <div><strong>Session ID:</strong> {debugInfo.sessionId.substring(0, 20)}...</div>
        )}
      </div>

      <div style={{ backgroundColor: '#f5f5f5', padding: '15px', marginBottom: '15px', borderRadius: '8px' }}>
        <h2 style={{ fontSize: '16px', marginBottom: '10px' }}>Backend Config:</h2>
        <div><strong>REACT_APP_BACKEND_URL:</strong> {debugInfo.backendUrl}</div>
        <div><strong>API Base URL:</strong> {debugInfo.apiBase}</div>
      </div>

      <div style={{ backgroundColor: '#f5f5f5', padding: '15px', marginBottom: '15px', borderRadius: '8px' }}>
        <h2 style={{ fontSize: '16px', marginBottom: '10px' }}>Cookies:</h2>
        <div style={{ wordBreak: 'break-all' }}>
          {debugInfo.cookies || '(no cookies)'}
        </div>
      </div>

      <div style={{ backgroundColor: '#f5f5f5', padding: '15px', marginBottom: '15px', borderRadius: '8px' }}>
        <h2 style={{ fontSize: '16px', marginBottom: '10px' }}>Session Check Result:</h2>
        {debugInfo.sessionCheckResult && (
          <div style={{ color: 'green' }}>✅ {debugInfo.sessionCheckResult}</div>
        )}
        {debugInfo.sessionCheckError && (
          <div style={{ color: 'red' }}>
            ❌ Error: {debugInfo.sessionCheckError} (Status: {debugInfo.sessionCheckStatus})
          </div>
        )}
      </div>

      {debugInfo.hasSessionId && (
        <div style={{ marginTop: '20px' }}>
          <button
            onClick={testProcessSession}
            style={{
              padding: '15px 30px',
              fontSize: '16px',
              backgroundColor: '#6FCFD3',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer'
            }}
          >
            🔧 Manually Process Session
          </button>
          <p style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
            Click this if you have a session_id in the URL but aren't logged in
          </p>
        </div>
      )}

      {debugInfo.processResult && (
        <div style={{ backgroundColor: '#d4edda', padding: '15px', marginTop: '15px', borderRadius: '8px' }}>
          <strong>Process Result:</strong> {debugInfo.processResult}
        </div>
      )}

      {debugInfo.processError && (
        <div style={{ backgroundColor: '#f8d7da', padding: '15px', marginTop: '15px', borderRadius: '8px' }}>
          <strong>Process Error:</strong> {debugInfo.processError}
        </div>
      )}

      <div style={{ marginTop: '30px', padding: '15px', backgroundColor: '#fff3cd', borderRadius: '8px' }}>
        <h3 style={{ fontSize: '14px', marginBottom: '10px' }}>📋 Instructions:</h3>
        <ol style={{ fontSize: '12px', lineHeight: '1.6' }}>
          <li>If "Has session_id?" shows ❌ NO, the OAuth callback didn't complete</li>
          <li>If it shows ✅ YES, click "Manually Process Session" button</li>
          <li>Take a screenshot of this page and share with support</li>
        </ol>
      </div>

      <div style={{ marginTop: '20px' }}>
        <button
          onClick={() => window.location.href = '/'}
          style={{
            padding: '10px 20px',
            fontSize: '14px',
            backgroundColor: '#D66238',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer'
          }}
        >
          ← Back to Landing
        </button>
      </div>
    </div>
  );
};

export default AuthDebug;
